import { Card, Col, Row, Spin, Statistic, Typography } from 'antd';
import { useCallback, useEffect, useState } from 'react';
import { api } from '../../api/client';
import { crmBrandName, crmEnvLabel, crmPublicHost } from '../../branding/crmBrand';

const ONLINE_POLL_MS = 30_000;

export default function DashboardPage() {
  const [onlineCount, setOnlineCount] = useState<number | null>(null);
  const [onlineLoading, setOnlineLoading] = useState(true);

  const loadOnlineCount = useCallback(async () => {
    try {
      const { data } = await api.get<{ onlineCount: number }>('/admin/drivers/online-count');
      setOnlineCount(data.onlineCount);
    } catch {
      setOnlineCount(null);
    } finally {
      setOnlineLoading(false);
    }
  }, []);

  useEffect(() => {
    void loadOnlineCount();
    const id = setInterval(() => void loadOnlineCount(), ONLINE_POLL_MS);
    return () => clearInterval(id);
  }, [loadOnlineCount]);

  return (
    <div>
      <Typography.Title level={3} style={{ marginTop: 0, fontWeight: 700 }}>
        {crmBrandName} 營運儀表板
      </Typography.Title>
      <Typography.Paragraph type="secondary" style={{ fontSize: 15, marginBottom: 20 }}>
        {crmEnvLabel} ·
        {' '}
        車輛分佈、派單效率、Stripe/PayPal 對帳報表將在此擴展；API 已預留 maps / payments / locations 模組。
      </Typography.Paragraph>
      <Row gutter={[16, 16]}>
        <Col xs={24} md={12} xl={6}>
          <Card className="crm-page-card">
            {onlineLoading && onlineCount === null ? (
              <Spin />
            ) : (
              <Statistic
                title="當前上線司機"
                value={onlineCount ?? '—'}
                suffix={onlineCount != null ? '位' : undefined}
              />
            )}
            <Typography.Text type="secondary" style={{ fontSize: 12 }}>
              已審批且在 App 開啟上線；每 {ONLINE_POLL_MS / 1000} 秒更新
            </Typography.Text>
          </Card>
        </Col>
        <Col xs={24} md={12} xl={6}>
          <Card className="crm-page-card">
            <Statistic title="環境" value={crmEnvLabel} />
          </Card>
        </Col>
        <Col xs={24} md={12} xl={6}>
          <Card className="crm-page-card">
            <Statistic title="域名" value={crmPublicHost} />
          </Card>
        </Col>
        <Col xs={24} md={12} xl={6}>
          <Card className="crm-page-card">
            <Statistic title="派單級別邏輯" value="管理員 2 秒 → 合作方 → 公海" />
          </Card>
        </Col>
      </Row>
    </div>
  );
}
